export default {"src":"/assets/turbo/c1abfdc9/lascanaat/_next/static/media/coffee-cat.104e100c.svg","height":193,"width":191,"blurWidth":0,"blurHeight":0};